module.exports = __webpack_public_path__ + "img/sample_storyboard_1.5594b5d1.jpg";